<template>
  <div class="about">
    <van-sticky >
    <van-nav-bar title="常见问题" :border="false"  left-arrow  @click-left="goBack" >
    </van-nav-bar>
    </van-sticky>

    <van-cell-group v-if="viewType=='list'">
      <van-cell title="测速达标" is-link />
      <van-cell title="宽带提速规则说明" is-link  />
      <van-cell title="查看支持宽带提速的区域"  is-link />
      <van-cell title="如何绑定和解绑微信？"  is-link />
    </van-cell-group>

    <van-collapse v-model="activeName" accordion>
      <van-collapse-item title="测速达标" name="1">
        <p>一、宽带未达标</p>
        <p>影响宽带测速未达标的因素有很多，如：</p>
        <p>1、Wifi频段影响；</p>
        <p>wifi频段为2.4G，wifi信号最大支持下载速率为54Mbps，若签约带宽大于或等于54Mbps，请使用支持无线信号模式为802.11n、802.11ac路由器。</p>
        <p>2、无线wifi 周围环境的影响</p>
        <p>请保持手机机与路由器距离保持1米左右，避免中间有障碍物遮挡。</p>
        <p>3、开启多资源消耗型应用</p>
        <p>导致测速结果低于签约带宽，请关闭其他应用再测速。</p>
        <p></p>
        <p>二、移动测速未达标</p>
        <p>影响移动测速未达标的因素有很多，如：</p>
        <p>1、基站网络覆盖不够；</p>
        <p>附近的基站可能较远，或者大型障碍物遮挡。</p>
        <p>2、附件移动用户上网用户多</p>
        <p>附件移动上网用户越来越多，导致附近基站都人满为患，随机带来的就是网速均分到每个人身上没有多少。</p>
        <p>3、手机基带信号接收不良</p>


      </van-collapse-item>
      <van-collapse-item title="宽带提速规则说明" name="2">
        <p>1、宽带提速是什么？</p>
        <p>宽带提速是运营商官方授权的宽带服务，直接提升家庭接入带宽，让您畅享高带宽极速网络。如：家庭带宽可从100M提升到200M。</p>
        <p>2、宽带提速后是不是只对当前设置有效？</p>
        <p>宽带提速是提升家庭宽带的物理网速，当前宽带下接入的所有上网设备都会被提速。比如您的宽带从20M提速至100M，就相当于您开通了100M的宽带，您的所有上网设备都会享受这100M的网速。</p>
        <p>3、我家的宽带是否支持宽带提速？</p>
        <p>由于宽带环境复杂，当前宽带是否支持提速以及所支持的提速值，请以APP自动查询的结果为准。</p>
        <p>4、如何通过网查查APP进行家庭带宽提速？</p>
        <p>手机连接想要提速的家庭宽带WiFi，购买会员即可提速。</p>
        <p>5、家里宽带已经买了提速会员，可以在其他地方使用手机远程提速吗？</p>
        <p>使用手机提速时，需连接到有提速会员的宽带WiFi下才能进行提速。暂不支持远程提速。</p>
        <p>6、手机在移动网络下，可以给家庭宽带提速吗？</p>
        <p>不可以。请连接家庭宽带WiFi后再尝试提速。</p>
        <p>7、已经是提速会员，如何自动提速？</p>
        <p>手机已经装了网查查APP应用，打开网查查APP且连接了有提速会员的宽带网络时，自动提速。</p>
        <p style="color: #ff4341">特别说明：网查查APP单次提速持续120分钟，如果提速超过120分钟，如果网查查APP处于激活状态会自动提速，不在激活状态重新打开网查查APP 自动提速。</p>
        <p>8、换了新宽带，之前购买的提速会员还能用吗？</p>
        <p>提速会员仅针对购买时终端所联网的宽带线路生效。若换了新宽带，之前未使用完的提速时间，不支持转移到新宽带上。</p>
        <p>【提速异常】</p>
        <p>1、为什么之前都能用，今天突然提速失败了？</p>
        <p>此种情况可能的原因是：</p>
        <p>1. 运营商智能管道能力平台故障，需等待运营商修复</p>
        <p>2. 运营商平台用户信息配置有误</p>
        <p>3. 部分地区运营商更换设备后，新设备暂不支持提速</p>
        <p>4. 出现此种情况的用户可重启拨号设备（路由及光猫）进行再提速尝试</p>
        <p>2、之前提速正常，为什么突然提速无效果？</p>
        <p>1）请先检查宽带是否在提速状态中。</p>
        <p>2）检查一下自家的网络环境，比如网线口是否松落等。</p>
        <p>3）确认网络环境和提速状态没有问题后，重启光猫、路由器等设备，重拨之后再尝试提速。</p>
        <p>【特殊问题】</p>
        <p>1、提速后没有实际效果或效果不好？</p>
        <p>超过100M的网络都属于千兆网络范畴，需要光猫、路由器、网卡都具备千兆能力，任何一个设备不支持千兆网速都会影响整体网速体验。请先确认使用的设备能够支持。 如果设备没有问题，建议先使用测速工具测试提速后带宽，确定是否有提速效果。确定没有效果后，建议联系当地运营商，检查宽带配置是否有问题。</p>
        <p>2、提速遇到问题该如何反馈？</p>
        <p>在您提速过程中，如果遇到什么问题需要我们帮您解决，请在网查查APP客服电话023-86763377向我们反馈！感谢您的支持！</p>

      </van-collapse-item>
      <van-collapse-item title="查看支持宽带提速的区域" name="3">
        <p>中国电信宽带用户</p>
        <p>1、开通省份</p>
        <p>北京、天津、河北、山西、内蒙、辽宁、吉林、黑龙江、上海、江苏</p>
        <p>浙江、安徽、福建、江西、山东、河南、湖北、湖南</p>
        <p>海南、重庆、四川、贵州、云南、西藏、陕西、甘肃、青海、宁夏、新疆</p>
        <p><van-icon name="success" />	备注： 广东、广西提速能力暂不支持。</p>
        <p>2、省份提速策略</p>
        <table width="95%"  class="wcc-table" style="font-size: 10px;"  cellspacing="0" >
          <tr class="wcc-tb-header">
            <td style="width: 40%">区域</td>
            <td style="width: 10%">宽带类型</td>
            <td style="width: 25%">用户签约带宽</td>
            <td style="width: 25%">提速策略</td>
          </tr>
          <tr>
            <td rowspan="2">北京、福建、甘肃、贵州、海南、河北、河南、黑龙江、湖北、湖南、吉林、江西、辽宁、内蒙古、宁夏、青海、山东、陕西、上海、四川、天津、西藏、新疆、浙江、重庆</td>
            <td rowspan="4">家庭宽带用户</td>
            <td>签约带宽<100M</td>
            <td>提速到100M</td>
          </tr>
          <tr>
            <td>签约带宽=100M</td>
            <td>提速到200M</td>
          </tr>
          <tr>
            <td>江苏、山西、云南</td>
            <td>签约带宽<100M</td>
            <td>提速到100M</td>
          </tr>
          <tr>
            <td>安徽</td>
            <td>签约带宽<30M</td>
            <td>提速到30M</td>
          </tr>
        </table>


        <p>中国联通宽带用户</p>
        <p>1、开通省份</p>
        <p>北京、重庆、四川、浙江、福建、宁夏、江苏、青海、湖北、山东、天津、广东、山西、辽宁、上海、陕西、河北、黑龙江、内蒙、吉林</p>
        <p>2、省份提速策略</p>
        <table width="95%"  class="wcc-table" style="font-size: 10px;"  cellspacing="0" >
          <tr class="wcc-tb-header">
            <td style="width: 20%">区域</td>
            <td style="width: 10%">宽带类型</td>
            <td style="width: 38%">用户签约带宽</td>
            <td style="width: 32%">提速策略</td>
          </tr>
          <tr>
            <td>北京</td>
            <td rowspan="20">家庭宽带用户</td>
            <td>1、签约带宽<100M <br>2、签约带宽<200M <br>3、签约带宽<500M</td>
            <td>1、提速到100M<br>2、提速到200M<br>3、提速到500M</td>
          </tr>
        <tr>
          <td>重庆</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M</td>
        </tr>
        <tr>
          <td>四川</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M</td>
        </tr>
        <tr>
          <td>浙江</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        <tr>
          <td>福建</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到500M</td>
        </tr>
        <tr>
          <td>宁夏</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        <tr>
          <td>江苏</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到500M</td>
        </tr>
        <tr>
          <td>青海</td>
          <td>1、签约带宽<200M<br>2、签约带宽<300M</td>
          <td>1、提速到200M<br>2、提速到300M</td>
        </tr>
        <tr>
          <td>湖北</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M</td>
          <td>1、提速到100M<br>2、提速到200M</td>
        </tr>
        <tr>
          <td>山东</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M</td>
        </tr>
        <tr>
          <td>天津</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        <tr>
          <td>广东</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到500M</td>
        </tr>
        <tr>
          <td>山西</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        <tr>
          <td>辽宁</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M</td>
        </tr>
        <tr>
          <td>上海</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        <tr>
          <td>陕西</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        <tr>
          <td>河北</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        <tr>
          <td>黑龙江</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        <tr>
          <td>内蒙</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        <tr>
          <td>吉林</td>
          <td>1、签约带宽<100M<br>2、签约带宽<200M<br>3、签约带宽<300M<br>4、签约带宽<500M</td>
          <td>1、提速到100M<br>2、提速到200M<br>3、提速到300M<br>4、提速到500M</td>
        </tr>
        </table>
        <p> </p>
        <p>中国移动宽带用户</p>
        <p>1、开通省份</p>
        <p>辽宁</p>
        <p>2、省份提速策略</p>
        <table width="95%"  class="wcc-table" style="font-size: 10px;"  cellspacing="0" >
          <tr class="wcc-tb-header">
            <td style="width: 20%">区域</td>
            <td style="width: 10%">宽带类型</td>
            <td style="width: 38%">用户签约带宽</td>
            <td style="width: 32%">提速策略</td>
          </tr>
          <tr>
            <td>辽宁</td>
            <td>家庭宽带用户</td>
            <td>1、签约带宽<100M <br>2、签约带宽<200M </td>
            <td>1、提速到100M<br>2、提速到200M</td>
          </tr>
        </table>

      </van-collapse-item>
<!--      <van-collapse-item title="如何绑定和解绑微信?" name="4">-->
<!--        如果您选择一键微信登录，根据提示会自动绑定当前账号，微信号绑定后不可以解绑。-->
<!--      </van-collapse-item>-->

      <van-collapse-item title="宽带提速会员购买帮助" name="5">
        <br>1、请在购买前认真确认当前WIFI对应宽带，是否是您需要购买的宽带提速会员宽带（如家庭宽带）。
        <br>2、如果宽带发生变更，原宽带的会员无法转移到新宽带上。
        <br>3、提速会员购买成功后立即生效。
        <br>4、提速会员有效期会根据您买的不同月份的会员产品自动生成不同的账期。
        <br>如：订购了3个月提速会员，起：订购时间X月X日， 止：订购时间X月X + 3月，超过有效期后提速会员自动失效。

      </van-collapse-item>

      <van-collapse-item title="我已购买了提速会员，但家庭宽带发生变更或想给另一条宽带购买会员该怎么办？" name="5.1">
        <br>1、请联系客服，并提供您的手机号码，客服人员帮您清除当前的提速会员信息；
        <br>2、将您的手机连接到您需要购买提速会员的新宽带网络上，如果新的宽带网络支持提速，便可进行购买。
        <br>注意：原宽带的提速会员无法转移到新的宽带上。
        <br>客服电话： 023 - 86763377
      </van-collapse-item>

      <van-collapse-item title="金币规则说明" name="6">

        <div class="wcc-content">当您微信登录网查查后，就可以通过网查查赚金币任务获取金币，金币可以兑换商品。
        </div>
        <div class="wcc-content">金币专属网查查，仅限网查查内使用，金币可累计，长期有效。

        </div>
        <div class="wcc-header-2">一、赚取金币
        </div>
        <div class="wcc-content">1、Wi-Fi网络测速
        </div>
        <div class="wcc-content">不同路由器每日首次测速完成，获得2金币，每日最多获取10次。

        </div>
        <div class="wcc-content">2、移动数据网络测速
        </div>
        <div class="wcc-content">不同基站（Cell-ID）每日首次测速完成，获得2金币，每日最多获取10次。

        </div>
        <div class="wcc-content">3、携号转网该选谁结果分享
        </div>
        <div class="wcc-content">每日首次转网建议分享完成，获得5金币。

        </div>
        <div class="wcc-content">4、测速结果分享
        </div>
        <div class="wcc-content">每日首次测速结果分享，获得5金币。

        </div>
        <div class="wcc-content">5、邀请好友安装APP
        </div>
        <div class="wcc-content">邀请好友安装使用APP，获得300金币，每日最多获取3次。


        </div>
        <div class="wcc-header-2">二、金币使用
        </div>
        <div class="wcc-content">您在通过兑换商品使用金币,请认真阅读每个礼品的兑换和使用规则。
        </div>
        <div class="wcc-content">1、实物礼品兑换
        </div>
        <div class="wcc-content">认真填写收货地址，如果收货地址填错，一切后果由您全部承担，网查查不退还所花积分，也不再邮寄兑换商品。
        </div>
        <div class="wcc-content">2、虚拟商品
        </div>
        <div class="wcc-content">提速包兑换后立即生效，请在查网络->宽带提速中去使用。

        </div>
        <div class="wcc-header-2">三、金币作弊
        </div>
        <div class="wcc-content">
          网查查严禁任何形式的作弊行为！网查查将使用合法的手段获取并分析可疑信息，一旦发现用户作弊，将马上对用户的金币进行清零处理。情况严重、性质恶劣的进行封号处理，并以涉嫌诈骗，向公安机关举报。在此过程中，若产生任何相关损失，均由作弊用户承担。

        </div>
        <div class="wcc-content">同时，为了维护网查查平台的公平环境和健康发展，若您发现作弊情况，请联系客服举报。举报核实后，将给予金币奖励。

        </div>
        <div class="wcc-header-2">四、免责条款
        </div>
        <div class="wcc-content">a) 金币不可转让，仅可在网查查内使用。
        </div>
        <div class="wcc-content">b) 您在通过兑换商品使用金币，详细使用规则以具体每个兑换商品的规则为准。
        </div>
        <div class="wcc-content">c) 网查查有权在未向您通知的情况下自行变更、终止全部或部分金币规则，网查查无须为金币规则的变更或终止承担任何责任。您对网查查的继续使用，视为您对金币规则变更和终止的接受。
        </div>
        <div class="wcc-content">d) 无论您的网查查账户因何种原因被关闭或者注销，您的金币将自动丧失，网查查无须为您的金币损失承担任何责任。
        </div>
        <div class="wcc-content">e) 金币规则以网查查公布的最新版本为准，最终解释权由网查查所有。


        </div>
        <div class="wcc-header-2">五、其他问题

        </div>
        <div class="wcc-content">如果您在金币获取过程中有任何疑问，请联系网查查客服进行咨询。

        </div>
        <div class="wcc-content">网查查邮箱：1632853310@qq.com

        </div>
        <div class="wcc-content">网查查客服电话：023-86763377

        </div>
      </van-collapse-item>
      <!--<van-collapse-item title="账号注销" name="7">-->
      <!--<div style="text-align: center;line-height: 50px">网查查注销须知</div>-->
      <!--<div class="wcc-content">在您申请注销网查查账号之前，请您认证阅读、理解并同意《网查查注销须知》。</div>-->

      <!--<div class="wcc-content">注销后，您将放弃以下权限（即使你使用相同的微信号再次登录并使用网查查）：</div>-->
      <!--<div class="wcc-content">1、注销网查查微信登录账号为不可恢复的操作。</div>-->
      <!--<div class="wcc-content">2、您登录的微信信息、绑定手机号信息、获得相关权益等将被清空且无法恢复。 </div>-->
      <!--<div class="wcc-content">3、您的测速记录、评测记录、以及其他参与记录将无法找回。</div>-->

      <!--<div v-if="$cookie.get('session')"-->
      <!--style="text-align: center!important;margin: 30px auto">-->
      <!--&lt;!&ndash;          已登录才显示&ndash;&gt;-->

      <!--<van-checkbox v-model="checked"-->
      <!--shape="square" icon-size="1.2em"-->
      <!--style="margin: 25px">已阅读并同意《网查查注销须知》</van-checkbox>-->

      <!--<van-button type="info" size="small" :disabled="!checked" @click="signout">立即注销</van-button>-->

      <!--</div>-->

      <!--</van-collapse-item>-->

      <van-collapse-item title="苹果手机由于系统原因，缺少一些功能" name="8">

        <div class="wcc-content">由于系统原因，网查查APP在苹果手机中无法提供或有差异的功能如下：</div>
        <div class="wcc-content">Wi-Fi测速时不一定能提供ssid </div>
        <div class="wcc-content">Wi-Fi测速时不能提供wifi频段 </div>
        <div class="wcc-content">Wi-Fi测速时苹果手机获得的WIFI信号强度不准确，某些型号不能获取 </div>
        <div class="wcc-content">Wi-Fi测速时不能提供协商连接速率 </div>
        <div class="wcc-content">Wi-Fi测速后，不能提供“为什么未达标”的检测服务 </div>
        <div class="wcc-content">移动网络测速时，不能提供cell id </div>
        <div class="wcc-content">移动网络测速时，不能提供信号强度 </div>
        <div class="wcc-content">查故障中的“宽带网络问题”不能提供“专业调优”服务 </div>
        <div class="wcc-content">专项检测中，不能提供“路由器质量检测”服务 </div>
        <div class="wcc-content">专项检测中，不能提供“移动信号检测”服务</div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
  export default {
    data:function(){
      return {
        viewType:'list1',
        activeName:"0",
        checked:false
      }
    },
    methods:{
      goBack:function(){
        if(window.JSInterface) {
          window.JSInterface.callMethod('close', null)
        }
        else if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface){
          window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"close\"}");
        }
      },
      signout:function(){
        this.axios.post("/openApi/signout");
        if(window.JSInterface) {
          window.JSInterface.callMethod('reset', null)
        }
        else if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface){
          window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"reset\"}");
        }
      }
    }
  }
</script>

<style>
  .wcc-table td{
    border-top: 1px solid #353f53;
    border-left: 1px solid #353f53;
    padding: 3px;
  }
  .wcc-table{
    margin: 0 auto;
    border-bottom: 1px solid #353f53;
    border-right: 1px solid #353f53;
  }
  .wcc-tb-header{
    text-align: center;
    background-color: #1c3146;
  }

   .van-collapse-item__content{
     background-color: inherit!important;
   }

  .van-checkbox__label{
    color: inherit;
  }
  .wcc-header-1{
    text-align: center;
    font-size: 1.2em;
    line-height: 2em;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .wcc-header-2{
    font-size: 1.1em;
    line-height: 2em;
    font-weight: bold;
  }
  .wcc-content{
    text-indent: 2em;
    margin-bottom: 10px;
  }
</style>
